// extracted by mini-css-extract-plugin
export default {"container":"UILibrary_container__ft8dZ","heading":"UILibrary_heading__BtDOR"};